// Alias en PascalCase: los nombres de archivo vienen con snake_case y ESLint
// no acepta <JugadoresActivos /> como componente JSX.
import JugadoresActivos from "views/jugadores/components/Jugadores_page";
import JugadoresInactivos from "views/jugadores/components/JugadoresInactivos_page";
import Card from "components/card";

/**
 * Activos e inactivos en dos tarjetas. La segunda columna aparece recién en xl:
 * en tablet las tablas quedaban demasiado angostas para sus 5 columnas.
 */
const JugadoresPage = () => {
  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
      <Card extra="select-none flex w-full flex-col p-5 text-left sm:p-6">
        <JugadoresActivos />
      </Card>
      <Card extra="select-none flex w-full flex-col p-5 text-left sm:p-6">
        <JugadoresInactivos />
      </Card>
    </div>
  );
};

export default JugadoresPage;
